import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  isOpenCRFModel: false,
  selectedCRFRow: [],
  selectedCRFOID: '',
  vistCRFData: {}
};
export const crfForms = createSlice({
  name: 'CRFForms',
  initialState,
  reducers: {
    openCRFModel: (state, action: PayloadAction<any>) => {
      state.isOpenCRFModel = action.payload;
    },
    setSelectedCRFRow: (state, action: PayloadAction<any>) => {
      state.selectedCRFRow = action.payload;
    },
    setSelectedCRFOID: (state, action: PayloadAction<any>) => {
      state.selectedCRFOID = action.payload;
    },
    setVistCRFData: (state, action: PayloadAction<any>) => {
      state.vistCRFData = { ...state.vistCRFData, ...action.payload };
    }
  }
});

export const { openCRFModel, setSelectedCRFRow, setSelectedCRFOID, setVistCRFData } = crfForms.actions;
